// extracted by mini-css-extract-plugin
module.exports = {"container":"DetailButton_container__2Xabp","hovercheck":"DetailButton_hovercheck__1fXMs","detail":"DetailButton_detail__aysB5","arrow":"DetailButton_arrow__MaWms"};